import { useEffect } from 'react'
import LoadCSSforfirstTime from '../../../CloudStorage/LoadCSSforfirstTime';
import { useDispatch, useSelector } from 'react-redux';
import { getSettings } from '../../../redux/Contacts/action';
import axiosInstance from '../../../redux/api';
import { useFormik } from "formik";
import * as Yup from "yup";
import { urtoast } from '../../Layouts/CustomPopup/eventEmitter';
import { descriptionvalidation, namevalidation } from '../../Common/commonvalidation';
import { handleCharactersKeyDown, handleNameKeyDown } from '../../Common/FewCommonMethods';
import AsteriskLabel from '../../Common/AsteriskLabel';


const validation = Yup.object().shape({
  name: namevalidation,
  email: Yup.string()
    .email("Invalid email format")
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Invalid email format")
    .required("Email is required"),
  message: descriptionvalidation,
});


const DashboardContactus = () => {
  const dispatch = useDispatch();
  const path = "Assets/scss/contactus.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getSettings());
  }, []);

  const theSettingDetails = useSelector(
    ({ settingsDetails: { settingList } }) => settingList
  );

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      message: "",
    },
    validationSchema: validation,
    onSubmit: (values) => handleSubmit(values),
  });

  const handleSubmit = (values) => {
    axiosInstance
      .post("contact", values)
      .then((res) => {
        formik.resetForm();
        urtoast(res.data.response.message, 1);
      })
      .catch((e) => {
        console.log(e.message, "error");
        urtoast(e.message, 2);
      });
  };

  return (
    <div className="dashboardcontactus">
      <h1>Contact Us</h1>
      <div className="row">
        <div className="col-md-6">
          <div className="contact-left">
            <h4>Get in Touch</h4>
            <div className="d-flex flex-column contact-flex">
              {theSettingDetails && (
                <a>
                  <i class="fa-solid fa-phone"></i>{" "}
                  <span onClick={() => window.location.href = `tel:${theSettingDetails?.direct_call}`}>
                    {theSettingDetails?.direct_call}
                  </span>
                </a>
              )}

              {theSettingDetails?.email_id && (
                <a>
                  <i class="fa-regular fa-envelope"></i>{" "}
                  <span onClick={() => window.location.href = `mailto:${theSettingDetails?.email_id}`}>
                    {theSettingDetails?.email_id}
                  </span>
                </a>
              )}

              <a >
                <i class="fa-brands fa-whatsapp" style={{ color: "#73AD57", fontSize: '20px' }}></i>{" "}
                <span onClick={() => window.open(`https://wa.me/${theSettingDetails?.whatsapp_call}`, "_blank")}>
                  {theSettingDetails?.whatsapp_call}
                </span>
              </a>

            </div>
            {theSettingDetails && (
              <div className="social-link pb-5">
                <h4>Follow us</h4>
                <div className="shares">
                  <div className="shares">
                    <a href={theSettingDetails?.facebook}>
                      <i class="fa-brands fa-facebook-f"></i>
                    </a>
                    <a href={theSettingDetails?.twitter}>
                      <i class="fa-brands fa-x-twitter"></i>
                    </a>
                    <a href={theSettingDetails?.instagram}>
                      <i class="fa-brands fa-instagram"></i>
                    </a>
                    <a href={theSettingDetails?.youtube}>
                      <i class="fa-brands fa-linkedin-in"></i>
                    </a>
                  </div>
                </div>
              </div>
            )}
            {theSettingDetails && (
              <div className="social-link">
                <h4>Download Our App</h4>
                <div className="shares">
                  <div className="shares">
                    <a href={theSettingDetails?.apple_store}>
                      <i class="fa-brands fa-apple"></i>
                    </a>
                    <a href={theSettingDetails?.play_store}>
                      <i class="fa-brands fa-google-play"></i>
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="col-md-6">
          <div className="contact-right">
            <h4>Send us message </h4>
            <form onSubmit={formik.handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name <AsteriskLabel /></label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  className="form-control"
                  style={{ width: "100%" }}
                  placeholder="Enter Your Name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onKeyDown={handleNameKeyDown}
                />
                {formik.errors.name && formik.touched.name && (
                  <p style={{ color: "red" }}>{formik.errors.name}</p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email <AsteriskLabel /></label>

                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Enter Your email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
                {formik.errors.email && formik.touched.email && (
                  <p style={{ color: "red" }}>{formik.errors.email}</p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="message">Message <AsteriskLabel /></label>

                <textarea
                  className="form-control"
                  rows="5"
                  style={{ width: "100%" }}
                  id="message"
                  name="message"
                  placeholder="Enter Your message"
                  value={formik.values.message}
                  onChange={formik.handleChange}
                />
                {formik.errors.message && formik.touched.message && (
                  <p style={{ color: "red" }}>{formik.errors.message}</p>
                )}
              </div>
              <button className="buttons background-button" type="submit">
                <span> Send Message</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardContactus